import {fadeIn, fadeOut} from "./utilities/fade";

export function showMobileMenu(menu, overlay, toggle) {
    fadeIn(overlay, 200, "linear", function () {
        menu.classList.add("open");
        document.body.classList.add("menu-open");
        toggle.classList.add("active");
    });
}

export function hideMobileMenu(menu, overlay, toggle) {
    menu.classList.remove("open");
    document.body.classList.remove("menu-open");
    toggle.classList.remove("active");
    fadeOut(overlay);
}